import { css } from '@ringcentral/juno';

export const resetStyle = css`
  margin: 0;
  padding: 0;
  border: 0;
  font: inherit;
  line-height: 1;
`;
